import React from 'react';
import DialogForm from 'Components/Core/DialogForm';
import FormElement from 'Components/Core/Form/FormElement';

// Watchlist-Auswahl (Gruppen) fuer MarketdataWatchlist.js und
// MarketdataQuotes.js - bewusst als eigene, in sich geschlossene Komponente
// (haelt Gruppenliste/Dialog selbst), damit beide Module identisch aussehen
// und sich verhalten, ohne Logik zu duplizieren. Meldet die Auswahl nur nach
// aussen (onSelect), der Elternkomponente bleibt uebrig, ihre eigene Liste/
// Live-Ansicht bei einem Wechsel neu zu laden.
//
// Eigenes Dropdown statt eines nativen <select> - <option>-Elemente koennen
// kein Hover-Icon zum Umbenennen zeigen (Browser-natives UI, kein CSS/JS-
// Zugriff auf einzelne Optionen).
export default function MarketdataGroupSelector({ x, id, onSelect }) {

	const wafId = id + '-group';
	const dialogFormId = 'form-group-' + id;
	const [groups, setGroups] = React.useState([]);
	const [selectedGroupId, setSelectedGroupId] = React.useState(null);
	const [open, setOpen] = React.useState(false);
	const containerRef = React.useRef(null);

	function loadGroups(onDone) {
		x.was.axPost('Backend/webapp.php?module=Marketdata&task=MarketdataWatchlistGroupList', {}, (result) => {
			if (result.data.returncode !== 1) {
				return;
			}
			const rows = result.data.content || [];
			setGroups(rows);
			setSelectedGroupId((current) => (current && rows.some((row) => row.groupid === current)) ? current : (rows[0]?.groupid ?? null));
			if (onDone) onDone(rows);
		});
	}

	React.useEffect(() => {
		loadGroups();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	React.useEffect(() => {
		if (selectedGroupId !== null) {
			onSelect(selectedGroupId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedGroupId]);

	// Dropdown bei Klick ausserhalb schliessen.
	React.useEffect(() => {
		if (!open) {
			return;
		}
		function handleClickOutside(e) {
			if (containerRef.current && !containerRef.current.contains(e.target)) {
				setOpen(false);
			}
		}
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [open]);

	function selectGroup(groupId) {
		setSelectedGroupId(groupId);
		setOpen(false);
	}

	function openCreateDialog() {
		x.waf.setAddSend(wafId, 'id', 0);
		x.waf.set(wafId, 'name', '');
		x.wad[dialogFormId].setTitle('Neue Watchlist anlegen');
		x.wad[dialogFormId].show(() => { x.waf.focus(wafId, 'name') });
		setOpen(false);
	}

	function openRenameDialog(group) {
		x.waf.setAddSend(wafId, 'id', group.groupid);
		x.waf.set(wafId, 'name', group.name);
		x.wad[dialogFormId].setTitle('Watchlist umbenennen');
		x.wad[dialogFormId].show(() => { x.waf.focus(wafId, 'name') });
		setOpen(false);
	}

	// Nach dem Anlegen die neue Watchlist gleich auswaehlen (result.content.groupid
	// ist nur beim Anlegen gesetzt, siehe MarketdataWatchlistGroupSave.inc) -
	// beim Umbenennen bleibt die Auswahl unveraendert, es wird nur der Name aktuell.
	function afterSend(result) {
		if (result.returncode !== 1) {
			return;
		}
		loadGroups((rows) => {
			if (result.content?.groupid) {
				const created = rows.find((row) => row.groupid === result.content.groupid);
				if (created) {
					setSelectedGroupId(created.groupid);
				}
			}
		});
	}

	const currentGroup = groups.find((group) => group.groupid === selectedGroupId);

	return (
		<span className="marketdata-group-selector" ref={containerRef}>
			<DialogForm
				id={dialogFormId}
				x={x}
				wafId={wafId}
				title="Watchlist"
				classes="marketdata-group-dialog"
				module="Marketdata"
				sendTask="MarketdataWatchlistGroupSave"
				onAfterSend={afterSend}
			>
				<FormElement type="text" x={x} wafId={wafId} id="name" mandatory={true} title="Name" fieldValue="" maxLength="100" />
			</DialogForm>
			<button type="button" className="marketdata-group-current" onClick={() => setOpen((current) => !current)}>
				<span>{currentGroup?.name ?? '…'}</span>
				<i className="bi bi-chevron-down" />
			</button>
			{open &&
				<div className="marketdata-group-dropdown">
					<div className="marketdata-group-dropdown-item marketdata-group-dropdown-new" onClick={openCreateDialog}>
						<i className="bi bi-folder-plus" /> Neue Watchlist anlegen
					</div>
					<div className="marketdata-group-dropdown-separator" />
					{groups.map((group) => (
						<div
							key={group.groupid}
							className={'marketdata-group-dropdown-item' + (group.groupid === selectedGroupId ? ' marketdata-group-dropdown-item-active' : '')}
							onClick={() => selectGroup(group.groupid)}
						>
							<span>{group.name}</span>
							<i className="bi bi-pencil marketdata-group-edit-icon" title="Umbenennen" onClick={(e) => { e.stopPropagation(); openRenameDialog(group); }} />
						</div>
					))}
				</div>
			}
		</span>
	);
}
